<template>
  <!-- <v-col :cols="cols" md="12" sm="12" xs="12"> -->
    <v-card class="custom-card" >

      <!-- Discount Badge -->
      <div v-if="discountPercent" class="discount-badge">
        {{ discountPercent }}% OFF
      </div>

      <v-img :src="image" height="200px" aspect-ratio="1" cover class="custom-img" loading="lazy"></v-img>

      <v-card-title class="price-tag">
        <span class="original-price" v-if="originalPrice">Rs.{{ originalPrice }}</span>
        <span class="discount-price">Rs. {{ price }}</span>
      </v-card-title>

      <v-card-text class="content-area">
        <h3 class="custom-card-title">{{ title }}</h3>
        <p class="custom-card-subtitle">{{ subtitle }}</p>
      </v-card-text>

      <v-card-actions>
        <v-btn block class="custom-btn">ORDER NOW</v-btn>
      </v-card-actions>
    </v-card>
  <!-- </v-col> -->
</template>

<script setup>
import { defineProps, computed } from "vue";

const props = defineProps({
  title: String,
  price: String, // Discounted price
  originalPrice: String, // Original (crossed) price
  subtitle: String,
  image: String,
  cols: {
    type: [Number, String],
    default: 12,
  },
});

// Compute discount percentage
const discountPercent = computed(() => {
  const original = parseFloat(props.originalPrice);
  const discounted = parseFloat(props.price);
  if (!original || !discounted || original <= discounted) return null;
  return Math.round(((original - discounted) / original) * 100);
});
</script>

<style scoped>
/* Card Styling */
.custom-card {
  width: 100%;
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  background-color: white;
}

.custom-card:hover {
  transform: translateY(-5px);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.15);
}

.custom-img {
  border-radius: 15px 15px 0 0;
  transition: transform 0.3s;
}

.custom-card:hover .custom-img {
  transform: scale(1.05);
}

/* Discount Badge */
.discount-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ff3e3e;
  color: white;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 5px;
  z-index: 3;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

/* Price Tag */
.price-tag {
  position: absolute;
  top: 160px;
  right: 15px;
  background: linear-gradient(135deg, #5761e7, #4552c1);
  color: #fff;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 8px;
  z-index: 2;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.original-price {
  text-decoration: line-through;
  color: #ccc;
  font-size: 13px;
  margin-right: 8px;
}

.discount-price {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

/* Content */
.content-area {
  padding: 15px;
}

/* Title */
.custom-card-title {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Subtitle */
.custom-card-subtitle {
  font-size: 14px;
  line-height: 20px;
  color: #6b7c93;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Button */
.custom-btn {
  text-transform: uppercase;
  font-weight: 600;
  background: linear-gradient(135deg, #5761e7, #4552c1);
  color: white;
  border-radius: 8px;
  transition: background 0.3s ease-in-out, transform 0.2s;
}

.custom-btn:hover {
  background: linear-gradient(135deg, #4552c1, #3642a4);
  transform: scale(1);
}
</style>
